<template>
  <div>
    <div class="details_content_repeat">
      <QS-h4-title title="订单基本信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :column="4"
          :source="source"
          :list="baseInfoList"
          :separator="columnSeparator"
          label-width="max-content"
        >
        </column-box-expand>
      </div>
    </div>
    <!--租赁信息-->
    <div class="details_content_repeat">
      <QS-h4-title title="租赁信息" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :column="4"
          :source="source"
          :list="personalLeaseInfo"
          :separator="columnSeparator"
          label-width="max-content"
        >
        </column-box-expand>
      </div>
    </div>

    <!-- 司机合作配置 -->
    <div
      class="details_content_repeat"
      v-if="rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI"
    >
      <QS-h4-title title="司机合作配置" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :column="4"
          :source="source"
          :list="driverCooperationConfig"
          :separator="columnSeparator"
          label-width="max-content"
        >
        </column-box-expand>
      </div>
    </div>


    <!-- 租赁合同 -->
    <div class="details_content_repeat">
      <QS-h4-title title="租赁合同" />
      <div class="details_content_repeat_hundred">
        <column-box-expand
          :column="4"
          :source="source"
          :list="personalLeaseContractInfo"
          :separator="columnSeparator"
          label-width="max-content"
        >
        </column-box-expand>
      </div>
    </div>
  </div>
</template>
<script>
import { orderDetailInfoV2 } from '@/api/domain/orders'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import { payModeList, payPlanTypeList, PAY_MODE } from '@/components/DriverCooperationRules/DriverSettlementConfig/config.js'


export default {
  name: 'orderDetail',
  props: {
    orderId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      source: {},
      signType: {
        0: '线下',
        1: '线上',
      },
      baseInfoList: [
        {
          key: 'bizTypeName',
          name: '订单类型',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'createUser',
          name: '订单创建人',
        },
        {
          key: 'storeName',
          name: '所属门店',
        },
      ],
      // 个人租赁信息
      personalLeaseInfo: [
        {
          key: 'rentCategoryName',
          name: '租赁类别',
        },
        {
          key: 'planName',
          name: '租赁方案',
        },
        {
          key: 'signDate',
          name: '合同签署日期',
        },
        {
          key: 'startEndDate',
          name: '收款起止日期',
        },
        {
          key: 'presentDays',
          name: '赠送天数(天)',
        },
        {
          key: 'rentDays',
          name: '租赁天数',
        },
        {
          key: 'deposit',
          name: '押金总金额(元)',
        },
        {
          key: 'rentAmount',
          name: '租金总金额(元)',
        },
        {
          key: 'spName',
          name: '完单平台',
        },
      ],
      // 司机合作配置
      driverCooperationConfig: [
        {
          key: 'cooPayMode',
          name: '结算周期',
        },
        {
          key: 'cooPayDay',
          name: '结算日期',
        },
        {
          key: 'cooPayPlanType',
          name: '结算模式',
        },
        {
          key: 'cooCommission',
          name: '结算金额',
        },
      ],
      // 租赁合同信息
      personalLeaseContractInfo: [
        {
          key: 'signName',
          name: '签署方式',
        },
        {
          key: 'merchantName',
          name: '签约主体',
        },
        {
          key: 'computedContractUrl',
          name: '合同附件',
        },
      ],
      rentCategory: '',
      CATEGORY_CODE_MAP,
    }
  },
  created() {
    this.orderDetail()
  },
  methods: {
    async orderDetail() {
      const { code, data } = await orderDetailInfoV2({ orderId: this.orderId })
      if (code === 1) {
        this.rentCategory = data.rentCategory
        let driverCooData = {}

        if (data.feePayPlanType !== 2) {
          this.personalLeaseInfo = this.personalLeaseInfo.filter((item) => item.name !== '完单平台')
        }

        // 司机合作模式不展示押金总金额
        if (data.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
          this.personalLeaseInfo = this.personalLeaseInfo.filter((item) => item.key !== 'deposit')
          // 司机合作模式字段
          driverCooData = {
            cooPayMode: payModeList[data.cooPayMode],
            cooPayDay: data.cooPayMode === PAY_MODE.WEEK
              ? `周${['一', '二', '三', '四', '五', '六', '日'][Number(data.cooPayDay) - 1] || data.cooPayDay}`
              : `${data.cooPayDay}号`,
            cooPayPlanType: payPlanTypeList[data.cooPayPlanType],
          }

          if (data.cooPayMode === PAY_MODE.DAY) {
            this.driverCooperationConfig = this.driverCooperationConfig.filter((item) => item.key !== 'cooPayDay')
          }
        }


        if (data.contractUrl) {
          data.computedContractUrl = this.getURL({
            data: data.contractUrl,
            needName: true,
            defaultImg: [],
          })
          data.computedContractUrl = data.computedContractUrl?.[0]?.url
          this.personalLeaseContractInfo.find((item) => item.key === 'computedContractUrl').downFile = {
            url: data.computedContractUrl,
            name: '合同附件',
          }
        }
        if (data.startDate && data.endDate) {
          data.startEndDate = `${data.startDate} ~ ${data.endDate}`
        }
        data.presentDays = data.presentDays !== null ? `${data.presentDays}天` : '--'
        data.rentDays = data.rentDays !== null ? `${data.rentDays}天` : '--'
        data.deposit = data.deposit !== null ? `${data.deposit}元` : '--'
        data.signName = this.signType[data.signType]

        this.source = {
          ...data,
          ...driverCooData,
        }
      }
    },
  },
}
</script>
